/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLatestReport.defs.js'
export { main as default } from './getLatestReport.defs.js'
